import { render } from "./ModalBigger.vue?vue&type=template&id=484d66ca&scoped=true"
import script from "./ModalBigger.vue?vue&type=script&lang=js"
export * from "./ModalBigger.vue?vue&type=script&lang=js"

import "./ModalBigger.vue?vue&type=style&index=0&id=484d66ca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484d66ca"]])

export default __exports__